import React from "react";
import { Link } from "react-router-dom";

import about1 from '../../assets/images/about/1.jpg'
import about2 from '../../assets/images/about/2.jpg'
import about3 from '../../assets/images/about/4.jpg'
import about4 from '../../assets/images/about/6.jpg'
import client1 from '../../assets/images/client/01.jpg'
import dashboard from '../../assets/images/saas/dashboard.png'

import Navbar from "../../components/navbar";
import AnalyticsTwo from "../../components/analyticsTwo";
import PricingOne from "../../components/pricingOne";
import HelpCenter from "../../components/helpCenter";
import GetInTuch from "../../components/getInTuch";
import Footer from "../../components/footer";
import ScrollTop from "../../components/scrollTop";

import { FiArrowRight, MdOutlineCheckCircle } from '../../assets/icons/icons'
import { principles } from "../../data/data";

export default function IndexSaas(){
    return(
        <>
        <Navbar/>

        <section className="bg-half-130 d-table w-100">
            <div className="container">
                <div className="row mt-5 justify-content-center">
                    <div className="col-12">
                        <div className="heading-title text-center">
                            <h4 className="heading fw-bold mb-4">Digital experiences <br/> crafted with dedication.</h4>
                            <p className="para-desc mx-auto text-muted">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                            <div className="mt-4 pt-2">
                                <Link to="#" className="btn btn-primary m-1">Documentation</Link>
                                <Link to="#" className="btn btn-soft-primary m-1">Get Started <FiArrowRight className="fea icon-sm"/></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <img src={dashboard} className="img-fluid rounded-md shadow-md" alt=""/>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row">
                    {principles.slice(0,3).map(( item, index ) =>{
                        let Icon = item.icon
                        return(
                            <div className="col-lg-4 col-md-6 mt-4 pt-2" key={index}>
                                <div className="card border-0 text-center features feature-primary">
                                    <div className="icon text-center mx-auto rounded-circle">
                                        <h3 className="mb-0"><Icon/></h3>
                                    </div>

                                    <div className="card-body p-0 mt-4">
                                        <h5>{item.title}</h5>
                                        <p className="text-muted">{item.desc}</p>
                                        <div className="mt-2">
                                            <Link to="#" className="link">Read More <FiArrowRight className="fea icon-sm"/></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>
        <div className="position-relative">
            <div className="shape overflow-hidden text-light">
                <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                </svg>
            </div>
        </div>

        <section className="section bg-light">
            <div className="container">
                <AnalyticsTwo/>
            </div>
        </section>
        <div className="position-relative">
            <div className="shape overflow-hidden text-white">
                <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                </svg>
            </div>
        </div>

        <section className="section">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-md-7 order-1 order-md-2">
                        <div className="ms-lg-5">
                            <div className="section-title">
                                <h6 className="text-primary">Collaborate</h6>
                                <h4 className="title mb-4">Collaborate with your <br/> team anytime, anywhere.</h4>
                                <p className="text-muted para-desc mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                            </div>

                            <ul className="list-unstyled text-muted mb-0 mt-4 row col-12">
                                <li className="list-inline-item col-lg-6 col-md-6 col-6 m-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Organize your data</li>
                                <li className="list-inline-item col-lg-6 col-md-6 col-6 m-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Work with any team</li>
                                <li className="list-inline-item col-lg-6 col-md-6 col-6 m-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Business analytics</li>
                                <li className="list-inline-item col-lg-6 col-md-6 col-6 m-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Always in sync</li>
                                <li className="list-inline-item col-lg-6 col-md-6 col-6 m-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Embedded analytics</li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-md-5 order-2 order-md-1 mt-4 mt-sm-0 pt-2 pt-sm-0">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-6 col-6">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="card rounded border-0 shadow overflow-hidden">
                                            <img src={about1} className="img-fluid" alt=""/>
                                        </div>
                                    </div>
    
                                    <div className="col-lg-12 col-md-12 mt-4 pt-2">
                                        <div className="card rounded border-0 shadow overflow-hidden">
                                            <img src={about2} className="img-fluid" alt=""/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-6 col-6">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="card rounded border-0 shadow overflow-hidden">
                                            <img src={about3} className="img-fluid" alt=""/>
                                        </div>
                                    </div>
    
                                    <div className="col-lg-12 col-md-12 mt-4 pt-2">
                                        <div className="card rounded border-0 shadow overflow-hidden">
                                            <img src={about4} className="img-fluid" alt=""/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row justify-content-center">
                    <div className="col-lg-8 col-md-10">
                        <div className="text-center">
                            <h1 className="display-2"><i className="mdi mdi-format-quote-open text-primary"></i></h1>
                            <p className="text-muted h5 fst-italic">" It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. The most well-known dummy text is the 'Lorem Ipsum', which is said to have originated in the 16th century. "</p>

                            <div className="mt-4">
                                <img src={client1} className="img-fluid avatar avatar-md-md rounded-circle shadow" alt=""/>
                                <h6 className="text-primary mt-3 mb-0">Thomas Israel</h6>
                                <small className="text-muted">C.E.O</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div className="position-relative">
            <div className="shape overflow-hidden text-light">
                <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                </svg>
            </div>
        </div>

        <section className="section bg-light">
            <div className="container">
               <PricingOne/>
            </div>

            <div className="container mt-100 mt-60">
                <HelpCenter/>

                <div className="row mt-5 pt-md-5 justify-content-center">
                    <GetInTuch/>
                </div>
            </div>
        </section>
        <Footer/>
        <ScrollTop/>
        </>
    )
}